import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        $(this.element).select2({theme: "erp", tags: true, width: '100%', dropdownParent: $(this.element.closest(".dialog") || document.body)});
    }
}
